// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__8Z--y","focado":"OptionSelect_focado__0HEuA"};